"use strict";

import oscar from "./components/oscar_ui";

$(function(){
    const optionsEl = document.getElementById('basket_js_options');
    if (optionsEl !== null ) {
        const options = JSON.parse(optionsEl.textContent);
        oscar.basket.init(options);
    }
});
